module.exports = __webpack_public_path__ + "fonts/Vonnes-BoldCond.12a1b7c6.otf";